import * as STATES from '../../utils/category/states';
import Badge from './Badge';
import type { BadgeProps } from './Badge';
import { InvalidImageBadge } from './InvalidImageBadge';
import * as config from './badgeConfig';

type MappedBadgeComponent = React.FC<{
  compact?: boolean;
  showTooltip?: boolean;
}>;

function createBadge(badgeConfig: BadgeProps): MappedBadgeComponent {
  const component: MappedBadgeComponent = ({ compact, showTooltip }) => (
    <Badge {...badgeConfig} compact={compact} showTooltip={showTooltip} />
  );
  component.displayName = `Badge(${badgeConfig.label})`;
  return component;
}

const mappings: Record<string, MappedBadgeComponent> = {
  [STATES.STATE_NOT_AVAILABLE_TO_MARKET]: createBadge(config.notAvailable),
  [STATES.STATE_NEW]: createBadge(config.newBadge),
  [STATES.STATE_UNPUBLISHED]: createBadge(config.hide),
  [STATES.STATE_UNTRANSLATED]: createBadge(config.untranslated),
  [STATES.STATE_NOT_VERIFIED]: createBadge(config.notVerified),
  [STATES.STATE_NOT_VERIFIED_AUTO_TRANSLATED]: createBadge(config.autoTranslated),
  [STATES.STATE_NOT_VERIFIED_RENAMED]: createBadge(config.notVerifiedRenamed),
  [STATES.STATE_AUTOCATEGORISABLE]: createBadge(config.autoCategorised),
  [STATES.STATE_CATEGORY_TYPE_ACCESSORIES]: createBadge(
    config.categoryTypeAccessories,
  ),
  [STATES.STATE_CATEGORY_TYPE_SYSTEM]: createBadge(config.categoryTypeSystem),
  [STATES.STATE_CATEGORY_TYPE_FURNITURE]: createBadge(config.categoryTypeFurniture),
  [STATES.STATE_CATEGORY_TYPE_UNDEFINED]: createBadge(config.categoryTypeUndefined),
  [STATES.STATE_INVALID_CATEGORY_IMAGE]: InvalidImageBadge,
  [STATES.STATE_INACTIVE]: createBadge(config.inactiveShop),
};

export default mappings;
